import axios from 'axios';

const basePath = '/assessments';

// TODO remove any
export const assessmentService = {
  getAssessmentById: (assessmentId: string): Promise<any> => axios.get(`${basePath}/${assessmentId}`),
};
